import React from 'react'
// import {Link} from 'react-router-dom'
import LoginForm from './../common/login-form'

class Login extends React.Component{
	constructor(props) {
		super(props);
	}

	componentDidMount = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	}
	render(){
		return(
			<div className="About">
				<section class="contact-img-area">
		            <div class="container">
		                <div class="row">
		                    <div class="col-md-12 text-center">
		                        <div class="con-text">
		                            <h2 class="page-title">login</h2>
		                            <p><a href="#">Home <i class="fa fa-angle-right"></i></a> login</p>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </section>
		        <section class="design-area home-five" >
				  	<div class="container">
				  		<LoginForm />		   
				  	</div>
				</section>
			</div>
			)
	}
}
export default Login;